import "./style.scss";
import { Link } from "react-router-dom";
import { headerNavLinks } from "@/src/constants/header";
import { HeaderSubMenuIcon } from "@/src/svg/HeaderSubMenuIcon";
import HeaderDeskSubMenuSlider from "./HeaderDeskSubMenuSlider/HeaderDeskSubMenuSlider";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";

interface HeaderSubMenuProps {
  isHovering: boolean;
  activeSubmenu: { id: string; text: string; description: string; link: string }[];
  activeMenuId: string | null | undefined;
  handleMouseEnterZone: () => void;
  handleMouseLeaveZone: () => void;
}

const HeaderSubMenu = ({
  isHovering,
  activeSubmenu,
  activeMenuId,
  handleMouseEnterZone,
  handleMouseLeaveZone,
}: HeaderSubMenuProps) => {
  return (
    <div
      className={`sub-menu ${isHovering && activeSubmenu.length > 0 ? "visible" : ""}`}
      onMouseEnter={handleMouseEnterZone}
      onMouseLeave={handleMouseLeaveZone}
    >
      <div className="sub-menu-content container">
        <div className="sub-menu-content-body">
          <p className="sub-menu-content-body-title">
            {headerNavLinks.find((item) => item.id === activeMenuId)?.text}
          </p>
          <div className="sub-menu-content-body-grid">
            {activeSubmenu.map((sub) => (
              <Link to={sub.link} key={sub.id} className="sub-menu-content-body-grid-card">
                <HeaderSubMenuIcon />
                <div>
                  <p className="card-title">{sub.text}</p>
                  <p className="card-description">{sub.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="sub-menu-content-news">
          <p className="sub-menu-content-news-title">WE OFFERS</p>
          <HeaderDeskSubMenuSlider />
          <ReadMoreBtn
            text="Read More →"
            link="#"
            className="sub-menu-content-news-read-more-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderSubMenu;
